var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasImage())?_c('div',{staticClass:"container-show-detail",style:(`background-image: url(${_vm.returnImage()})`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }